<template>
<div>
    <FormulaireContact/>
</div>
</template>

<script>
import FormulaireContact from '@/components/FormulaireContact.vue';
import { useHead } from '@vueuse/head';

    export default {
        name: 'ContactView',
        components: {
            FormulaireContact,
        },
        mounted() {
    // Réinitialiser le scroll lorsque le composant est complètement monté
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  },
  setup() {
    useHead({
      title: 'Me contacter',
      meta: [
        { name: 'description', content: 'Contactez-moi via ce formulaire pour toute collaboration ou question sur mes projets.' },
        { name: 'keywords', content: 'contact, réalisateur, documentaires, films' },
        { property: 'og:title', content: 'Contactez-moi - Pablo Cirès' },
        { property: 'og:description', content: 'Utilisez le formulaire pour me poser vos questions ou discuter de collaboration.' },
        { property: 'og:url', content: 'https://www.pablocires.me/contact' },
        { property: 'og:type', content: 'website' },
      ],
    });
  },
    }
</script>

<style scoped>/* reset */

</style>